<template>
    <div class="container">
        <div class="" v-if="loading">
            <div class="row">
            <div class="loading-md"></div>
            </div>
        </div>
        <div v-else class="row" style="margin-top: 2em;">
            <div class="panel" style="">
                <div class="form-card">
                    <h4>Create Your Store Account</h4>{{ko}}{{business_open_to_agents}}
                    <form class="sp-form">
                    <div class="form-group" style="display: none;">
                        <label><input type="radio" v-model="business_agent" value="0"> Personal Business</label>
                        <label><input type="radio" v-model="business_agent" value="1"> Agent/Side Hustle Business</label>
                    </div>
                        <!-- Name -->
                        <div class="form-group">
                        <label> *Business Name  </label>
                        <input type="text" v-model="business.business_name"  placeholder="" class="form-control">
                        </div>
                        <!-- Name -->
                        <div class="form-group">
                        <label> *Business Username <span style="color:#ff0000" v-if="validate_user_name_error">{{validate_user_name_message}}</span></label>
                        <input type="text" v-model="business.business_user_name" @change="validateUserName" class="form-control">
                        </div>
                        <!-- Business -->
                        <div class="form-group">
                        <label>Select Business Category Type</label>
                        <select class="form-control" v-model="business_category_type">
                            <option value="1">Products</option>
                            <option value="2">Services</option>
                        </select>
                        </div>
                        <div class="form-group" v-if="business_category_type == 1">
                            <label>Select a Product Category</label>
                            <select class="form-control" v-model="business.business_category">
                                <option :value="undefined">Select</option>
                                <option v-for="category in business_product_categories" :value="category.category_id" :key="category.category_id">{{category.category_name}}</option>
                            </select>
                        </div>
                        <div class="form-group" v-if="business_category_type == 2">
                            <label>Select a Service Category</label>
                            <select class="form-control" v-model="business.business_category">
                            <option :value="undefined">Select</option>
                            <option v-for="category in business_service_categories" :value="category.category_id" :key="category.category_id">{{category.category_name}}</option>
                            </select>
                        </div>

                        <div style="display: none;">
                        <h5>Market Settings</h5>
                        <div class="form-group">
                            <label for="email" class="">Do you sell in any of these markets?</label>
                            <select class="form-control" v-model="business.business_market_group">
                            <option :value="undefined">Select a Market</option>
                                <option v-for="business_market_group in market_groups" :key="business_market_group.id" :value="business_market_group.business_market_group">{{business_market_group.business_market_group_name}}</option>
                            </select>
                        </div>
                        </div>

                        <div class="form-group">
                        <div class="boarding-messages">
                            <p style="color:#4617c7;">{{data_processing_message}}</p>
                        </div>
                        <p style="color:#ff0000;">{{data_error_message}}</p>
                        <div class="loading-sm" v-if="action_loading"></div>
                        <button :disabled="disable_btn" type="button" class="btn sp-button-02" @click="setUpNewBusiness">Create</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import AccountResources from '../../Template/script.js' //scripts
    //import Purchase from '../../../Purchase'
    import commonfunctions from "../../Resources/commonfunctions";
    export default {
        mixins: [commonfunctions],
        data () {
            return {
                //user:this.$store.getters['account/getUser'],
                ko:'ghg'
            }
        },

        methods: {
            setPage(){
                this.loading = false;
                if(this.$route.name == 'AddNewBusinessByAgent'){
                    this.ko = 'tt66'
                    this.getBusinessesOpenToAgents();
                    console.log('as333')
                }
            },
        },

        components: {
            
        },

        created: function(){
            this.setPage();
            this.getCategories();
        }

    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// AddBusiness.vue?2e83dc94